import { render } from "./Index.vue?vue&type=template&id=4c625feb"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Admin/Matches/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c625feb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c625feb', __exports__)) {
    api.reload('4c625feb', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=4c625feb", () => {
    api.rerender('4c625feb', render)
  })

}


export default __exports__